import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { DateFormats } from '../../../../providers/app-date-adapter';
import { DatePipe } from '@angular/common';
import { EmailReminder } from '../../../../dto/email-reminder';
import { PaymentEmailRemindersService } from '../../../../services/payment-email-reminders.service';

@Component({
  selector: 'app-sent-reminders',
  templateUrl: './sent-reminders.component.html',
  styleUrls: ['./sent-reminders.component.css'],
})

export class SentRemindersComponent implements OnInit, OnChanges {

  @Input() orderId: number;
  public emailReminders: EmailReminder[];
  public loadReminders: boolean;
  private _orderId: number;

  // Reminders
  public reminderCols = [
    { columnDef: 'type', header: 'Type', cell: (row: EmailReminder) => `${row.type.order}` },
    { columnDef: 'date', header: 'Date', cell: (row: EmailReminder) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime)}` },
  ];
  public reminderDisplayedColumns = this.reminderCols.map(c => c.columnDef);

  constructor(
    private datePipe: DatePipe,
    private emailRemindersService: PaymentEmailRemindersService,
  ) { }

  ngOnInit() {
  }

  initComponent(orderId: number) {
    this.loadReminders = true;
    this.emailRemindersService
      .getRemindersByOrder(orderId)
      .subscribe(result => {
        this.emailReminders = result.data;
        this.loadReminders = false;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._orderId = changes.orderId.currentValue;
    this.initComponent(this._orderId);
  }

}
